// extracted by mini-css-extract-plugin
export default {"contactPage":"contact_contactPage__pct-u","sideStrips":"contact_sideStrips__0VBO5"};